<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false" fullscreen>
        <div class="dataBox">
            <div class="title" v-if="model.report_type==1">技术服务周报</div>
            <div class="title" v-if="model.report_type==2">技术服务月报</div>
            <div class="title" v-if="model.report_type==3">技术服务季报</div>
            <div class="ftitle">{{model.title}}</div>
            <div class="dateBox">
                <span style="display: inline-block;width: 33%">监测单位：{{model.monitor_company}}</span>
                <span style="display: inline-block;width: 33%;text-align: center">数据日期：{{model.start_date}} ~ {{model.end_date}}</span>
                <span style="display: inline-block;width: 33%;text-align: right">报告日期：{{model.report_date}}</span>
            </div>
            <div class="title1">一、现场投入情况</div>
            <div class="title2">主要人力资源投入情况表</div>
            <div class="listBox">
                <el-table :data="personList" border stripe empty-text="无数据">
                    <el-table-column label="序号" align="center" width="100">
                        <template slot-scope="scope">
                            {{ scope.$index + 1 }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="position" label="职位" align="center"></el-table-column>
                    <el-table-column prop="name" label="姓名" align="center"></el-table-column>
                    <el-table-column prop="remark" label="备注" align="center"></el-table-column>
                </el-table>
            </div>
            <div class="title2">主要监测设备投入情况表</div>
            <div class="listBox">
                <el-table :data="deviceList" border stripe empty-text="无数据">
                    <el-table-column label="序号" align="center" width="100">
                        <template slot-scope="scope">
                            {{ scope.$index + 1 }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="device_name" label="设备名称" align="center"></el-table-column>
                    <el-table-column prop="device_model" label="型号" align="center"></el-table-column>
                    <el-table-column prop="part" label="使用部位" align="center"></el-table-column>
                    <el-table-column prop="count" label="数量" align="center" width="100"></el-table-column>
                    <el-table-column prop="remark" label="备注" align="center"></el-table-column>
                </el-table>
            </div>
            <div class="title1">二、工作成果</div>
            <div class="cg_txt">
                整理施工方作业报告{{model.report_count}}份，其中灌浆报告{{model.report_count1}}份，压水报告{{model.report_count3}}份，封孔报告{{model.report_count5}}份。
                通过监测数据生成监测报告{{model.extract_count}}份，其中灌浆报告{{model.extract_count1}}份，压水报告{{model.extract_count3}}份，封孔报告{{model.extract_count5}}份；
                生成抽检报告{{model.diff_count}}份，其中灌浆报告{{model.diff_count1}}份，压水报告{{model.diff_count3}}份，封孔报告{{model.diff_count5}}份。
            </div>
            <div class="editorBox" style="margin-top: 30px;">
                <vue-ueditor-wrap v-model="content2" :config="myConfig" editor-id="month_infosh_container1" @ready="UEditorReady1"></vue-ueditor-wrap>
            </div>
            <div class="title2">智能灌浆数据采集器监测报告数据汇总表</div>
            <div class="listBox">
                <el-table :data="dataList2" border stripe empty-text="无数据">
                    <el-table-column prop="pcode" label="单元编号" align="center" v-if="model.unit_type==1"></el-table-column>
                    <el-table-column prop="pname" label="单元名称" align="center" v-if="model.unit_type==1"></el-table-column>
                    <el-table-column prop="pcode" label="分部编号" align="center" v-if="model.unit_type==2"></el-table-column>
                    <el-table-column prop="pname" label="分部名称" align="center" v-if="model.unit_type==2"></el-table-column>
                    <el-table-column prop="grout_type" label="灌浆类型" width="130" align="center">
                        <template slot-scope="scope">
                            <span>{{ transEnu(scope.row.grout_type, "grout_type") }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="report_count" label="报告数量" align="center" width="100"></el-table-column>
                    <el-table-column prop="report_count_err" label="异常报告数量" align="center" width="120"></el-table-column>
                    <el-table-column label="总注浆量情况" align="center">
                        <el-table-column prop="grout_volume" label="施工方总注浆量(L)" align="center"></el-table-column>
                        <el-table-column prop="grout_volume1" label="监测数据总注浆量(L)" align="center"></el-table-column>
                        <el-table-column prop="grout_volume_cha" label="差异值(L)" align="center"></el-table-column>
                        <el-table-column prop="grout_volume_cp" label="差异率" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.grout_volume_cp }}%</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="总注灰量情况" align="center">
                        <el-table-column prop="ash_volume" label="施工方总注灰量(kg)" align="center"></el-table-column>
                        <el-table-column prop="ash_volume1" label="监测数据总注灰量(kg)" align="center"></el-table-column>
                        <el-table-column prop="ash_volume_cha" label="差异值(kg)" align="center"></el-table-column>
                        <el-table-column prop="ash_volume_cp" label="差异率" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.ash_volume_cp }}%</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <!-- <el-table-column label="透水率情况" align="center">
                        <el-table-column prop="permeable_rate" label="施工方平均透水率(lu)" align="center"></el-table-column>
                        <el-table-column prop="permeable_rate1" label="监测数据平均透水率(lu)" align="center"></el-table-column>
                        <el-table-column prop="permeable_rate_cha" label="差异值(lu)" align="center"></el-table-column>
                        <el-table-column prop="permeable_rate_cp" label="差异率" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.permeable_rate_cp }}%</span>
                            </template>
                        </el-table-column>
                    </el-table-column> -->
                </el-table>
            </div>
            <div class="title2">非接触式智能灌浆监测装置抽检报告数据汇总表</div>
            <div class="listBox">
                <el-table :data="dataList4" border stripe empty-text="无数据">
                    <el-table-column prop="pcode" label="单元编号" align="center" v-if="model.unit_type==1"></el-table-column>
                    <el-table-column prop="pname" label="单元名称" align="center" v-if="model.unit_type==1"></el-table-column>
                    <el-table-column prop="pcode" label="分部编号" align="center" v-if="model.unit_type==2"></el-table-column>
                    <el-table-column prop="pname" label="分部名称" align="center" v-if="model.unit_type==2"></el-table-column>
                    <el-table-column prop="grout_type" label="灌浆类型" width="130" align="center">
                        <template slot-scope="scope">
                            <span>{{ transEnu(scope.row.grout_type, "grout_type") }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="report_count" label="报告数量" align="center" width="100"></el-table-column>
                    <el-table-column prop="report_count_err" label="异常报告数量" align="center" width="120"></el-table-column>
                    <el-table-column label="总注浆量情况" align="center">
                        <el-table-column prop="grout_volume" label="施工方总注浆量(L)" align="center"></el-table-column>
                        <el-table-column prop="grout_volume1" label="监测数据总注浆量(L)" align="center"></el-table-column>
                        <el-table-column prop="grout_volume_cha" label="差异值(L)" align="center"></el-table-column>
                        <el-table-column prop="grout_volume_cp" label="差异率" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.grout_volume_cp }}%</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="总注灰量情况" align="center">
                        <el-table-column prop="ash_volume" label="施工方总注灰量(kg)" align="center"></el-table-column>
                        <el-table-column prop="ash_volume1" label="监测数据总注灰量(kg)" align="center"></el-table-column>
                        <el-table-column prop="ash_volume_cha" label="差异值(kg)" align="center"></el-table-column>
                        <el-table-column prop="ash_volume_cp" label="差异率" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.ash_volume_cp }}%</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <!-- <el-table-column label="透水率情况" align="center">
                        <el-table-column prop="permeable_rate" label="施工方平均透水率(lu)" align="center"></el-table-column>
                        <el-table-column prop="permeable_rate1" label="监测数据平均透水率(lu)" align="center"></el-table-column>
                        <el-table-column prop="permeable_rate_cha" label="差异值(lu)" align="center"></el-table-column>
                        <el-table-column prop="permeable_rate_cp" label="差异率" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.permeable_rate_cp }}%</span>
                            </template>
                        </el-table-column>
                    </el-table-column> -->
                </el-table>
            </div>
            <div class="editorBox" style="margin-top: 30px;">
                <vue-ueditor-wrap v-model="content1" :config="myConfig" editor-id="month_infosh_container" @ready="UEditorReady"></vue-ueditor-wrap>
            </div>
            <div class="listBox" style="margin-top: 30px;">
                <el-table :data="logList" border stripe empty-text="无数据">
                    <el-table-column prop="real_name" label="操作人" align="center"></el-table-column>
                    <el-table-column prop="add_time" label="操作时间" align="center"></el-table-column>
                    <el-table-column prop="remark" label="记录" align="center"></el-table-column>
                </el-table>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="exportPDF()" size="medium">导出PDF</el-button>
            <el-button type="primary" @click="handleSubmit(2)" size="medium">审核通过</el-button>
            <el-button type="danger" @click="handleSubmit(3)" size="medium">审核不通过</el-button>
            <el-button type="primary" @click="closeDialog" size="medium" style="margin-right: 30px">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { getModelById } from '@/api/common'
import { shContent, exportPDF } from '@/api/monthreport'
import VueUeditorWrap from 'vue-ueditor-wrap';

export default {
    name: 'monthReportInfo',
    mixins: [editutil],
    components: {VueUeditorWrap},
    data() {
        return {
            model: {},
            personList: [],
            deviceList: [],
            dataList2: [],
            dataList4: [],
            logList: [],
            getObj:{
                url:'/api/admin/monthreport/info1',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['grout_type'],
            myConfig: {
                //你的UEditor资源存放的路径,相对于打包后的index.html
                UEDITOR_HOME_URL: '/ueditor/',
                //编辑器不自动被内容撑高
                autoHeightEnabled: false,
                autoFloatEnabled: false,
                //初始容器宽度
                initialFrameWidth: '100%',
                //初始容器高度
                initialFrameHeight: 280,
            },
            content1: '',
            content2: '',
            editor: null,
            editor1: null,
        };
    },
    methods: {
        UEditorReady() {
            this.editor = UE.getEditor('month_infosh_container');
        },
        UEditorReady1() {
            this.editor1 = UE.getEditor('month_infosh_container1');
        },
        getModelData() {
            this.model = this.copyObj(this.init_model);
            if (this.id > 0) {
                this.getObj.data.value = this.id;
                getModelById(this.getObj).then(res => {
                    if (res.code === 1) {
                        this.model = res.data.monthReport
                        this.personList = res.data.personList
                        this.deviceList = res.data.deviceList
                        this.dataList2 = res.data.dataList2
                        this.dataList4 = res.data.dataList4
                        this.logList = res.data.logList
                        this.content1 = this.model.content+""
                        this.content2 = this.model.content1+""
                        this.formateData();
                    } else {
                        this.$msg(res.msg)
                        this.closeDialog()
                    }
                })
            }
        },
        handleSubmit(state){
            var content_txt = this.content1
            var content_txt1 = this.content2
            shContent(this.id, state, content_txt, content_txt1).then(res=>{
                if(res.code == 1){
                    this.$msgs('审核成功')
                    this.$emit("on-close",{});
                }else{
                    this.$msg(res.msg)
                }
            })
        },
        resetModel() {
            this.model = {}
            this.personList = []
            this.deviceList = []
            this.dataList2 = []
            this.dataList4 = []
        },
        exportPDF(){
            const loading = this.$loading({
                lock: true,
                text: '正在执行...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            exportPDF(this.model.id).then(res=>{
                loading.close()
                if(res.code == 1){
                    window.open(res.data)
                }else{
                    this.$msg(res.msg)
                }
            })
        },
    }
};
</script>
<style lang="less" scoped>
    .dataBox {
        width: 100%;
        height: auto;
        padding: 0 30px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        font-size: 16px;
        color: #000;
    }
    .title {
        width: 100%;
        height: 60px;
        line-height: 60px;
        text-align: center;
        font-size: 28px;
        color: #000;
        font-weight: bold;
    }
    .ftitle {
        width: 100%;
        height: 60px;
        line-height: 60px;
        text-align: center;
        font-size: 24px;
        color: #000;
    }
    .dateBox {
        width: 100%;
        margin-top: 12px;
    }
    .title1 {
        width: 100%;
        font-size: 18px;
        margin-top: 30px;
    }
    .title2 {
        width: 100%;
        text-align: center;
        margin-top: 16px;
    }
    .listBox {
        width: 100%;
        margin-top: 15px;
    }
    .cg_txt {
        width: 100%;
        height: auto;
        margin: 10px;
        text-indent: 36px;
        line-height: 30px;
    }
    .editorBox {
        width: 100%;
        height: 300px;
        margin-top: 10px;
        margin-bottom: 30px;
    }
</style>